<template>
  <div
      class="fade show"
      :class="[classType]"
      role="alert"
      v-show="showAlert"
      v-if="showComponent"
      :title="qaAble ? showIfHasPermission?.toString() : null"
      :key="componentRefresh"
  >
    <slot></slot>
    <button type="button" class="close" aria-label="Close" @click.prevent="hide">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {
  name: 'ks-alert',
  mixins: [checkPermissions],
  props: {
    hideIn: {
      type: Number,
      default: null
    },
    type: {
      type: String,
      default: 'primary'
    },
    closable: {
      type: Boolean,
      default: null
    },
    initShow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    classType() {
      return `alert alert-${this.type} alert-dismissible`;
    },
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    },
  },
  mounted() {
    if (this.hideIn) {
      this.timeout = setTimeout(() => {
        this.showAlert = false;
        this.$emit('onHide', this);
      }, this.hideIn * 1000);
    }
  },
  methods: {
    show() {
      this.show = true;
      this.$emit('onShow', this);
    },
    hide() {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = null;
      this.show = false;
      this.$emit('onHide', this);
    }
  },
  data() {
    return {
      showAlert: this.initShow,
      timeout: null,
    }
  }

}
</script>
